import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import { Column } from './CustomTable';

const CustomTableHead = ({
  columns,
  setSelectedSort,
  selectedSort,
  showCheckbox,
  checkedIds,
  setCheckedIds,
  rows,
}: any) => {
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((row: any) => row.id);
      setCheckedIds(newSelected);
      return;
    }
    setCheckedIds([]);
  };

  return (
    <TableHead sx={{ marginBottom: '1rem' }}>
      <TableRow>
        {showCheckbox && (
          <TableCell padding="checkbox" sx={{ width: '48px' }}>
            <Checkbox
              color="primary"
              indeterminate={
                checkedIds.length > 0 && checkedIds.length < rows.length
              }
              checked={rows.length > 0 && checkedIds.length === rows.length}
              onChange={handleSelectAll}
            />
          </TableCell>
        )}
        {columns?.map(({ id, label = '', isSort, width }: Column) => (
          <TableCell
            key={id}
            sx={{
              width: width ?? 'auto',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: '14px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
            align="left"
            className="textBold"
            sortDirection={
              selectedSort?.id === id ? selectedSort?.value : false
            }>
            {label ? (
              <Tooltip title={label}>
                <span>
                  {isSort ? (
                    <TableSortLabel
                      active={selectedSort?.id === id}
                      direction={
                        selectedSort?.id === id ? selectedSort?.value : 'asc'
                      }
                      onClick={() => {
                        setSelectedSort({
                          id,
                          value: selectedSort.value === 'asc' ? 'desc' : 'asc',
                        });
                      }}>
                      {label}
                    </TableSortLabel>
                  ) : (
                    label
                  )}
                </span>
              </Tooltip>
            ) : (
              <span>{label}</span>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHead;
